'use client'

import { useEffect, useState } from 'react'
import { useCachedBookmarkedBlocksSWR } from '~/app/actions/progress'

function BookmarksCount({ courseId }: { courseId: string | number }) {
  const { data: bookmarks, isLoading } = useCachedBookmarkedBlocksSWR({
    courseId,
    suspense: false,
  })

  // Local state for INSTANT count updates
  const [localCount, setLocalCount] = useState<number>(0)

  // Sync local state with server data when it loads/changes
  useEffect(() => {
    if (bookmarks) {
      setLocalCount(bookmarks.length)
    }
  }, [bookmarks])

  // Don't show badge while loading
  if (isLoading) {
    return null
  }

  // Don't show badge if no bookmarks or count is 0
  if (localCount < 1) {
    return null
  }

  return (
    <span className="absolute -top-1 -right-1 sm:-top-2 sm:-right-2 flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 text-[10px] font-bold text-white">
      {localCount > 99 ? '99+' : localCount}
    </span>
  )
}

export default BookmarksCount
